import { NodeContext } from "../../poly/NodeContext";
import { AnimationContainer } from "../Animation";
import { AudioContainer } from "../Audio";
import { EventContainer } from "../Event";
import { GeometryContainer } from "../Geometry";
import { GlContainer } from "../Gl";
import { JsContainer } from "../Js";
import { ManagerContainer } from "../Manager";
import { MaterialContainer } from "../Material";
import { ObjectContainer } from "../Object";
import { TextureContainer } from "../Texture";
import { PostProcessContainer } from "../PostProcess";
import { RopContainer } from "../Rop";
export const ContainerClassMap = {
  [NodeContext.ACTOR]: AnimationContainer,
  [NodeContext.ANIM]: AnimationContainer,
  [NodeContext.AUDIO]: AudioContainer,
  [NodeContext.COP]: TextureContainer,
  [NodeContext.EVENT]: EventContainer,
  [NodeContext.GL]: GlContainer,
  [NodeContext.JS]: JsContainer,
  [NodeContext.MANAGER]: ManagerContainer,
  [NodeContext.MAT]: MaterialContainer,
  [NodeContext.OBJ]: ObjectContainer,
  [NodeContext.POST]: PostProcessContainer,
  [NodeContext.ROP]: RopContainer,
  [NodeContext.SOP]: GeometryContainer
};
